/**
 * Dispute status types shared between frontend and server.
 * Represents the user-facing state derived from chargebackHistory + users.disputeBanned.
 *
 * - null: No active dispute
 * - 'active_dispute': Dispute filed by user's bank, subscription suspended
 * - 'dispute_banned': 2+ disputes in 12 months, account banned from subscribing
 */

export type DisputeStatus = 'active_dispute' | 'dispute_banned';

/** Messages shown to users based on dispute status */
export const DISPUTE_BANNER_MESSAGES: Record<
  DisputeStatus,
  { title: string; description: string }
> = {
  active_dispute: {
    title: 'Account Restricted',
    description:
      'Your account has been temporarily restricted due to a payment dispute. Subscription features are paused until the dispute is resolved. Contact support if you believe this is an error.',
  },
  dispute_banned: {
    title: 'Account Suspended',
    description:
      'Your account has been suspended due to repeated payment disputes. Contact support for assistance.',
  },
};

/** Whether the banner should be shown for a given dispute status */
export function shouldShowDisputeBanner(
  status: DisputeStatus | null | undefined,
): status is DisputeStatus {
  return status === 'active_dispute' || status === 'dispute_banned';
}
